import { render, staticRenderFns } from "./UpSell.vue?vue&type=template&id=6a3a7bfe"
import script from "./UpSell.vue?vue&type=script&lang=ts"
export * from "./UpSell.vue?vue&type=script&lang=ts"
import style0 from "./UpSell.vue?vue&type=style&index=0&id=6a3a7bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports